import { message } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { constants } from "../../../constants/constants";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import YouTubeEmbed from "../../Banner/YouTubeEmbed";
import CustomHeaderTitle from "../../constants/CustomHeaderTitle";
import HeaderBread from "../../HeaderBread";
import Logs from "../../Logs";
import ActiveSwitchFile from "../../SwitchFile";
import CustomizedTable from "../../UI/CustomizedTable";
import {
  deleteShipMobilePage,
  getShipMobilePage,
  updateShipMobilePage,
} from "../../../utils/ApiCalls/AddShipMobilePage";
import moment from "moment";
import { getSailingDate } from "../../../utils/ApiCalls/SailingDates";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";

export const CustomListMobile = ({ category, type }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState();
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [sailing_date, setSailingDate] = useState(
    localStorage.getItem("sailing-date")
  );
  const [pageSize, setPageSize] = useState(10);
  const [active, setActive] = useState("listing");
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();
  const [sort, setSort] = useState("");
  const [vesselOptions, setVesselOptions] = useState([]);
  const [order, setOrder] = useState("");
  const [columns, setColumns] = useState([]);
  const [navigation, setNavigation] = useState([]);
  const [sailingOptions, setsailingOptions] = useState([]);

  const validDates = sailingOptions.map((item) =>
    moment(item.sailing_date).startOf("day")
  );
  useEffect(() => {
    if (category) getOptionLocation();
  }, [category]);
  useEffect(() => {
    if (category?.id)
      setNavigation([
        {
          title: "Home",
          route: "/",
        },
        {
          title: "Mobile App Ship CMS",
          route: "/",
        },
        {
          title: "All Pages",
          route:
            "/ship/all-pages/" +
            vesselOptions
              .find((item) => item.id == category?.vessel_id)
              ?.name?.toLowerCase()
              .replaceAll(" ", "-") +
            "/" +
            category.id,
        },
        {
          title: vesselOptions.find((item) => item.id == category?.vessel_id)
            ?.name,
          route:
            "/ship/all-pages/" +
            vesselOptions
              .find((item) => item.id == category?.vessel_id)
              ?.name?.toLowerCase()
              .replaceAll(" ", "-") +
            "/" +
            category.id,
        },
        {
          title: category?.name,
          route: "/ship/all-pages/genting-dream/" + category.id,
        },
      ]);
  }, [vesselOptions, category]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    let data = await getSailingDate({
      page: 1,
      limit: 2000,
      vessel_id: category?.vessel_id,
    });
    setsailingOptions(data?.data);
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const handleDelete = async (id, url) => {
    if (true || checkPermission(permission, "delete_per", "ships",window?.location?.pathname)) {
      await deleteShipMobilePage(id);
      // await deleteMenuList({ url });
      addlog("Mobile page Deleted", category?.name, { id }, userDetails.id);
      getData(page, sort, order);
    } else {
      message.error("Missing Permission for delete ");
    }
  };

  const handleUpdate = async (id, values, title, location_id) => {
    if (true || checkPermission(permission, "update_per", "Categories",window?.location?.pathname)) {
      let data = await updateShipMobilePage(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          "Categories " +
            (!values.valid_from
              ? values.is_active === 1
               ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          "Categories",
          { ...values, id, title },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };

  useEffect(() => {
    setColumns([
      {
        title: "No",
        width: 10,
        dataIndex: "id",
        key: "position",
        fixed: "left",
        render: (position, record, index) => (page - 1) * pageSize + index + 1,
      },
      {
        title: "Title/Venue",
        width: 10,
        dataIndex: "Title",
        key: "title",
          sorter: (a, b) => "",
        fixed: "left",
        render: (item, record) => (
          <render>
            {record?.shorePage?.title || record?.shorePage?.venue?.name}
          </render>
        ),
      },
      {
        title: "Sailing Date",
        width: 10,
        dataIndex: "sailing_date",
        key: "sailing_date",
        fixed: "sailing_date",
          sorter: (a, b) => "",
        render: (item, record) => moment(item).format("DD-MMM-YY"),
      },
      {
        title: "Parent Category",
        width: 10,
        dataIndex: "slug",
          sorter: (a, b) => "",
        key: "slug",
        fixed: "left",
        render: (item, record) => <render>{category?.name}</render>,
      },

      {
        title: "Image",
        width: 30,
        dataIndex: "image",
        
        key: "image",
        render: (image, record) => {
          if (record.content_type === "video") {
            return (
              <video
                src={`${constants.MEDIAURL}/${record?.shorePage?.image}`}
                style={{ width: "100px", height: "80px" }}
              >
                <track kind="captions" src="" label="English captions" />
              </video>
            );
          } else if (record.content_type === "link") {
            return (
              <YouTubeEmbed
                videoUrl={`${constants.MEDIAURL}/${image}`}
                width="100px"
                height="80px"
              />
            );
          } else {
            return (
              <img
                alt="banner"
                src={`${constants.MEDIAURL}/${record?.shorePage?.image}`}
                style={{ width: "100px", height: "80px" }}
              />
            );
          }
        },
      },
      {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        
        width: 30,
        sorter: (a, b) => "",
        render: (item, record, index) => (
          <ActiveSwitchFile
            item={item}
            record={record}
            index={index}
            handleUpdate={handleUpdate}
          />
        ),
      },
      {
        title: "Action",
        key: "operation",
        width: 30,
        render: (text, record) => (
          <div className="table_action_btn">
            <div
              onClick={() => {
                localStorage.setItem("old-url", window.location.pathname);
                localStorage.setItem("sailing-date", sailing_date);
                navigate(
                  "/ship/all-pages/" +
                    vesselOptions
                      .find((item) => item.id == category?.vessel_id)
                      ?.name?.replaceAll(" ", "-")
                      ?.toLowerCase() +
                    "/" +
                    +category.id +
                    "/edit/" +
                    record.id
                );
              }}
              className="btn"
            >
              <i
                className="ri-edit-2-line"
                data-toggle="tooltip"
                title="Edit"
              ></i>
            </div>
            <DeletePop
              onConfirm={() =>
                handleDelete(record.id, "our-ship/" + record.slug)
              }
            >
              <div>
                {" "}
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </div>
            </DeletePop>
          </div>
        ),
      },
    ]);
  }, [page, pageSize, search, category,vesselOptions]);

  const getData = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getShipMobilePage({
      catergory_id: category?.id,
      search: search,
      page: page,
      limit: pageSize,
      sailing_date: sailing_date,
    });
    setRows(data.data);
    setCount(data?.count);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    if (category?.id) getData();
  }, [category, page, pageSize, search, category, sailing_date]);

  return (
    <Layout type={"read_per"} allowPermission module_data={"ships"}>
      <CustomHeaderTitle title={"Deals"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={category?.name}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">
                    All {category?.name} Pages List
                  </h5>
                  <div>
                    Active Sailing :{" "}
                    <b>
                      {" "}
                      <DatePicker
                        style={{ width: "100%", height: "45px" }}
                        size="middle" // AntD supports "small" | "middle" | "large"
                        disabled={!category.vessel_id}
                        value={sailing_date ? dayjs(sailing_date) : null}
                        onChange={(date) =>
                          setSailingDate(date ? date.toISOString() : "")
                        }
                        disabledDate={(current) => {
                          if (!current) return true;

                          const isPastDate = current < dayjs().startOf("day");

                          // Allow only validDates
                          const isValidDate = validDates.some((d) =>
                            dayjs(d).isSame(current, "day")
                          );

                          return isPastDate || !isValidDate;
                        }}
                      />
                      {/* {moment(localStorage.getItem("sailing-date")).format(
                        "DD-MMM-YY"
                      )} */}
                    </b>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    ></div>
                    {rows && (
                      <CustomizedTable
                        setRows={setRows}
                        setPageSize={setPageSize}
                        setPage={setPage}
                        pageSize={pageSize}
                        page={page}
                        count={count}
                        columns={columns}
                        rows={rows}
                        title={"Cabin Category"}
                        sortHandler={() => {}}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>{" "}
        {active === "logs" && (
          <Logs
            type={"Page"}
            slug={"/website/webpages/our-ship/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};
